import { Callout, HTMLTable } from '@blueprintjs/core';
import _ from 'lodash';
import React, { FunctionComponent } from 'react';
import { t } from 'ttag';
import { LayerMetadata } from 'uf-api';
import { shouldHideColumn } from 'uf/layers/metadata';
import textStyles from 'uf/styles/text.module.css';
import ColumnMetadataSummary from './ColumnMetadataSummary';
import classNames from 'classnames';
import gridStyles from 'uf/styles/grid.module.css';

interface Props {
  layerMetadata: LayerMetadata;
  displayPanelView: boolean;
  charLimit?: number;
}
export const LayerColumns: FunctionComponent<Props> = props => {
  const { layerMetadata, displayPanelView, charLimit } = props;
  const { columns = [], unique_keys: uniqueKeys } = layerMetadata;
  // Hiding internal UF columns
  const visibleColumns = columns.filter(column => !shouldHideColumn(column));
  if (_.isEmpty(visibleColumns)) {
    return (
      <Callout icon={null} className={textStyles.centerAlign}>
        <small>{t`No additional attributes available for this dataset`}</small>
      </Callout>
    );
  }
  const tableClassName = classNames(
    gridStyles.table,
    gridStyles.tableLayerManager,
    {
      [gridStyles.simpleTableLayerManager]: displayPanelView,
    },
  );
  return (
    <HTMLTable className={tableClassName} striped width="100%">
      <thead>
        <tr className="h4">
          <th>{t`Column`}</th>
          <th>{t`Description`}</th>
          {!displayPanelView && <th>{t`Type`}</th>}
        </tr>
      </thead>
      <tbody>
        {visibleColumns.map(column => (
          <ColumnMetadataSummary
            key={column.key}
            charLimit={charLimit}
            columnMetadata={column}
            uniqueKeys={uniqueKeys}
            hideTypeColumn={displayPanelView}
          />
        ))}
      </tbody>
    </HTMLTable>
  );
};
